// extracted by mini-css-extract-plugin
module.exports = {"funkcjeContainer":"funkcje-systemu-crm-module--funkcjeContainer--3mJAe"};